import React from 'react';

import {
  FlagIcon,
  FuzzyLogoWhiteOrange,
  WaitingIcon,
} from '../../../assets/svg/SVGComponents';
import { IBoardRound } from '../../../dtos/IBoardSnapshot';
import { TConnectionStatus } from '../logic/BoardConnection';
import {
  colors,
  Footer,
  IconText,
  LiveDot,
  LiveIndicator,
  PoweredBy,
  Ticker,
  TickerTrack,
} from '../styles';

const STATUS_LABEL: Record<TConnectionStatus, string> = {
  connecting: 'conectando…',
  live: 'ao vivo',
  polling: 'ao vivo',
  offline: 'reconectando…',
};

interface ILiveFooterProps {
  rounds: IBoardRound[];
  status: TConnectionStatus;
}

/** Ticker das últimas rodadas encerradas + indicador de conexão (FE-05). */
const LiveFooter: React.FC<ILiveFooterProps> = ({ rounds, status }) => {
  const online = status === 'live' || status === 'polling';
  const items = rounds.map(round => (
    <IconText key={round.round_id}>
      <FlagIcon />
      <span>
        <strong>{round.team_name}</strong>
        {round.school_name ? ` (${round.school_name})` : ''} —{' '}
        <em>{round.total_score} pts</em>
        {round.arena_name ? ` · ${round.arena_name}` : ''}
      </span>
    </IconText>
  ));

  return (
    <Footer>
      <LiveIndicator $status={status}>
        {online ? (
          <LiveDot />
        ) : status === 'offline' ? (
          <LiveDot $color={colors.down} />
        ) : (
          <IconText>
            <WaitingIcon />
          </IconText>
        )}
        {STATUS_LABEL[status]}
      </LiveIndicator>
      <Ticker aria-label="Últimas rodadas encerradas">
        {items.length > 0 ? (
          // Conteúdo duplicado: o loop do marquee fica contínuo.
          <TickerTrack $duration={Math.max(20, items.length * 8)}>
            {items}
            {items.map(item =>
              React.cloneElement(item, { key: `${item.key}-copy` }),
            )}
          </TickerTrack>
        ) : (
          <span style={{ opacity: 0.6 }}>
            As rodadas encerradas aparecem aqui.
          </span>
        )}
      </Ticker>
      <PoweredBy>
        realização
        <FuzzyLogoWhiteOrange aria-label="Fuzzy Makers" role="img" />
      </PoweredBy>
    </Footer>
  );
};

export default LiveFooter;
